import React, { useEffect } from "react";
import { message, Layout, App as AntApp, Spin } from "antd";
import { useTranslation } from 'react-i18next';
import Login from "./components/Login";
import ChatRooms from "./components/ChatRooms";
import { useWebSocket } from "./contexts/WebSocketProvider";
import { WebSocketProvider } from "./contexts/WebSocketProvider"; 
import notificationService from "./services/NotificationService";
import { handleAuthError } from './utils/auth';
import { useAutoUnlockAudio } from './hooks/useAutoUnlockAudio';

const { Sider } = Layout;

const AppContent: React.FC = () => {
  const { 
    token, 
    setToken, 
    rooms, 
    setRooms, 
    status: wsStatus, 
    forceReconnect: handleForceReconnect, 
    setActiveRoom, 
    logout,
    isHistoryLoading,
    webSocket
  } = useWebSocket();
  const { t } = useTranslation();

  // Use the hook for auto unlocking audio on mouse movement
  useAutoUnlockAudio();
  
  // Try to auto-unlock audio on page load
  useEffect(() => {
    const attemptAutoUnlock = async () => {
      console.log('Attempting auto-unlock for audio notifications...');
      const success = await notificationService.attemptSilentAutoUnlock();
      if (!success) {
        console.log('Auto-unlock failed, user interaction required');
      }
    };

    attemptAutoUnlock();
  }, [token]);

  // Set up error handling
  useEffect(() => {
    const handleError = (error: any) => {
      handleAuthError(error);
    };

    window.addEventListener('unhandledrejection', (event) => {
      handleError(event.reason);
    });

    return () => {
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, []);

  // Показываем полноэкранный спиннер при загрузке истории
  if (token && isHistoryLoading) {
    return (
      <div className="loading-container">
        <Spin 
          size="large" 
          tip={t('chat.loading')}
          fullscreen 
        />
      </div>
    );
  }
  
  // Используем единую структуру для обоих состояний (авторизован/не авторизован)
  return (
    <Layout style={{ height: '100vh', background:'white' }}>
      {!token ? (
        // Обёртка для формы логина для центрирования
        <div className="login-wrapper" style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}>
          <Login 
            onLoginSuccess={(newToken: string) => {
              setToken(newToken);
              localStorage.setItem("token", newToken);
            }}
          />
        </div>
      ) : (
        <ChatRooms
          rooms={rooms}
          onRoomUpdate={(updatedRooms) => setRooms(updatedRooms)}
          onLogout={logout}
          wsStatus={wsStatus}
          onReconnect={handleForceReconnect}
          onActiveRoomChange={(roomId) => {
            setActiveRoom(roomId);
          }}
          webSocket={webSocket}
        />
      )}
    </Layout>
  );
};

// Wrap with WebSocketProvider and Ant Design App provider
const App: React.FC = () => {
  return (
    <AntApp>
      <WebSocketProvider>
        <AppContent />
      </WebSocketProvider>
    </AntApp>
  );
};

export default App; 